module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/user4-c0c1e75bb996f6231cecaea425ddc662.jpg";